module.exports = __webpack_public_path__ + "img/18.a5c086e7.jpg";